var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { Interactor } from '@veeam/core';
import { finalize } from 'rxjs/operators';
var DataTreeInteractor = /** @class */ (function (_super) {
    __extends(DataTreeInteractor, _super);
    function DataTreeInteractor(model, asyncNodesModel, config) {
        var _this = _super.call(this) || this;
        _this.model = model;
        _this.asyncNodesModel = asyncNodesModel;
        _this.config = config;
        _this.fetchNodeSubsMap = new Map();
        return _this;
    }
    DataTreeInteractor.prototype.didActivate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.subscriptions = this.model.fieldChanges('pagination').subscribe(function () {
                            _this.model.load();
                        });
                        this.subscriptions.add(this.model.fieldChanges('sorting').subscribe(function () {
                            _this.model.load();
                        }));
                        this.subscriptions.add(this.model.fieldChanges('filters').subscribe(function () {
                            _this.model.load();
                        }));
                        if (!this.config.autoLoad) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.model.load()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    DataTreeInteractor.prototype.didSelectionChange = function (nextSelection) {
        this.model.update(function (prevValue) {
            prevValue.selection = nextSelection;
        });
    };
    DataTreeInteractor.prototype.didCheckedChange = function (nextChecked) {
        this.model.update(function (prevValue) {
            prevValue.checked = nextChecked;
        });
    };
    DataTreeInteractor.prototype.didExpandChange = function (nextExpanded) {
        this.model.update(function (prevValue) {
            prevValue.expanded = nextExpanded;
        });
    };
    DataTreeInteractor.prototype.didToggleExpandNode = function (node, isExpanded) {
        var _this = this;
        if (node.isAsync()) {
            var id_1 = node.id;
            if (isExpanded) {
                this.asyncNodesModel.update(function (values) {
                    values.loadingIds = __spreadArrays(values.loadingIds, [id_1]);
                });
                this.fetchNodeSubsMap.set(id_1, this.model
                    .fetchNode(node)
                    .pipe(finalize(function () {
                    _this.removeAsyncNodeFromLoading(id_1);
                    _this.fetchNodeSubsMap.delete(id_1);
                }))
                    .subscribe(function (_a) {
                    var data = _a.data;
                    var _b, _c, _d;
                    var loadedNode = (_b = data.items) === null || _b === void 0 ? void 0 : _b[0];
                    if (loadedNode) {
                        _this.model.updatedItemById(id_1, loadedNode);
                        (_d = (_c = _this.config).onAsyncNodeLoad) === null || _d === void 0 ? void 0 : _d.call(_c, loadedNode);
                    }
                }, function (error) {
                    _this.asyncNodesModel.update(function (values) {
                        values.warningMap.push([id_1, error]);
                    });
                }));
            }
            else {
                this.abortFetchNode(id_1);
                this.removeAsyncNodeFromLoading(id_1);
                this.removeAsyncNodeFromWarning(id_1);
            }
        }
    };
    DataTreeInteractor.prototype.abortFetchNode = function (id) {
        var fetchNodeSubs = this.fetchNodeSubsMap.get(id);
        if (fetchNodeSubs) {
            fetchNodeSubs.unsubscribe();
            this.fetchNodeSubsMap.delete(id);
        }
    };
    DataTreeInteractor.prototype.removeAsyncNodeFromLoading = function (id) {
        this.asyncNodesModel.update(function (values) {
            values.loadingIds = values.loadingIds.filter(function (loadingId) { return loadingId !== id; });
        });
    };
    DataTreeInteractor.prototype.removeAsyncNodeFromWarning = function (id) {
        this.asyncNodesModel.update(function (values) {
            values.warningMap = values.warningMap.filter(function (warning) { return warning[0] !== id; });
        });
    };
    DataTreeInteractor.prototype.willDeactivate = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                (_a = this.subscriptions) === null || _a === void 0 ? void 0 : _a.unsubscribe();
                this.fetchNodeSubsMap.forEach(function (subs) {
                    subs.unsubscribe();
                });
                this.fetchNodeSubsMap.clear();
                return [2 /*return*/];
            });
        });
    };
    return DataTreeInteractor;
}(Interactor));
export { DataTreeInteractor };
//# sourceMappingURL=DataTreeInteractor.js.map